import React, { useMemo } from 'react';
import { ScrollSyncLink } from 'features/ScrollSync';
import styled from 'styled-components';
import { useLocation } from 'react-router';

interface SectionProps {
  title: string;
  level: string | number | null | undefined;
  current: boolean;
  id: string;
  element: HTMLElement;
}

export const Section = ({ title, level, current, id }: SectionProps) => {
  const location = useLocation();
  const to = useMemo(
    () => ({ pathname: location.pathname, search: location.search, hash: id }),
    [location.pathname, location.search, id],
  );
  return (
    <StyledSectionItem>
      <ScrollSyncLink
        scrollId={id}
        data-level={Number(level) + 1 || 1}
        className={current ? 'current' : ''}
        to={to}
        replace
      >
        {title}
      </ScrollSyncLink>
    </StyledSectionItem>
  );
};

const StyledSectionItem = styled.li`
  a {
    background-color: rgba(118, 103, 66, 0.05);
    border-left: 12px solid transparent;
    box-sizing: border-box;
    display: block;
    font-family: 'Zilla Slab', serif;
    font-size: 17px;
    margin-bottom: 2px;
    padding: 14px 5px 14px 10px;
    text-align: left;
    width: 100%;
    &:hover {
      border-left: 12px solid rgba(253, 186, 18, 0.3);
      cursor: pointer;
    }
    &:focus,
    &:visited:focus {
      margin-bottom: 2px;
      border-bottom: none;
    }
    &.current {
      border-left: 12px solid rgba(253, 186, 18, 1);
    }
    &[data-level] {
      padding-left: 200px;
    }
    ${[...Array(19)].map((_, i) => {
      return `&[data-level='${i + 1}'] {
        padding-left: ${(i + 1) * 11}px;
      }`;
    })}
  }
`;
